import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import { prefetchMovementV2PageDataFromApi, useMovementV2PageDataFromApi } from './pageData';

export type MovementV2PagePrefetchedContext = Readonly<{
	pageData: Parameters<typeof useMovementV2PageDataFromApi>[0];
}>;

export type MovementV2PageCombinedState = ReturnType<typeof useMovementV2PageDataFromApi>;

export function usePageContext(
	slug: string,
	prefetchedData?: MovementV2PagePrefetchedContext,
): MovementV2PageCombinedState {
	return useMovementV2PageDataFromApi(prefetchedData?.pageData, slug);
}

export async function prefetchPageContext(
	slug: string,
	context: PrefetchContext,
): Promise<MovementV2PagePrefetchedContext> {
	return { pageData: await prefetchMovementV2PageDataFromApi(context, slug) };
}

export type MovementV2PagePrefetchedDataProps = PrefetchedDataProps<MovementV2PagePrefetchedContext>;
